import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { gql, useQuery } from '@apollo/client'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from 'components/error'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { findIndex, some } from 'lodash'
import FormSubheader from '../create-profile-form/form-subheader'
import SelectionGroup from '../create-profile-form/selection-group'
import { getSelectionGroupIcon } from '../create-profile-form/selection-group-icons'
import {
  SelectionCheckboxList,
  SelectionCheckboxOption,
} from '../create-profile-form/selection-checkbox-option'
import { useCreateProfileFieldStyles } from '../create-profile-form/field-styles'

const ExperiencesQuery = gql`
  query Experiences {
    Experiences {
      message
      success
      experienceTypes {
        experienceTypeId
        typeName
        description
        experiences {
          experienceId
          experienceName
          experienceType
        }
      }
    }
  }
`

export const ExperienceStep = ({ experienceTypes, hideTitle = false }) => {
  const fieldClasses = useCreateProfileFieldStyles()
  const { register, control } = useFormContext()
  const { append, remove, fields } = useFieldArray({
    name: 'experiences',
    control,
  })

  const isChecked = (experienceId, checkedExperiences) => {
    return some(checkedExperiences, { experienceId })
  }

  const toggleExperienceChecked = (experienceId, checkedExperiences) => {
    isChecked(experienceId, checkedExperiences)
      ? remove(findIndex(checkedExperiences, { experienceId }))
      : append({ experienceId })
  }

  return (
    <Box className={fieldClasses.fieldSection}>
      {hideTitle ? (
        <FormSubheader
          title="Experience"
          description="Select the coaching experience that applies to you."
          required
        />
      ) : (
        <Typography variant="h4" gutterBottom>
          Experience *
        </Typography>
      )}
      <Box className={fieldClasses.fieldStack}>
        {experienceTypes.map(experienceType => (
          <SelectionGroup
            key={experienceType.typeName}
            title={experienceType.typeName}
            description={experienceType.description}
            icon={getSelectionGroupIcon(experienceType.typeName)}
          >
            <SelectionCheckboxList>
              {experienceType.experiences.map((experience, i) => (
                <SelectionCheckboxOption
                  key={experience.experienceId}
                  checked={isChecked(experience.experienceId, fields)}
                  label={experience.experienceName}
                  name={`experiences[${i}].experienceId`}
                  value={experience.experienceId}
                  onChange={() =>
                    toggleExperienceChecked(experience.experienceId, fields)
                  }
                />
              ))}
            </SelectionCheckboxList>
          </SelectionGroup>
        ))}
      </Box>
      <Box display="none" aria-hidden="true">
        {fields.map((item, index) => (
          <input
            key={item.id}
            type="hidden"
            ref={register()}
            name={`experiences[${index}].experienceId`}
            value={item.experienceId}
          />
        ))}
      </Box>
    </Box>
  )
}

export default function Experience({ hideTitle = false }) {
  const { data, loading, error } = useQuery(ExperiencesQuery)
  if (loading) return <LinearProgress color="primary" />
  if (error) return <Error error={error} />
  return (
    <ExperienceStep
      experienceTypes={data?.Experiences?.experienceTypes}
      hideTitle={hideTitle}
    />
  )
}
